import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2f56f689"
import script from "@/views/app.ts?vue&type=script&lang=js&external"
export * from "@/views/app.ts?vue&type=script&lang=js&external"
import style0 from "./App.vue?vue&type=style&index=0&id=2f56f689&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports